import { AccountType, LoginParams, SendMessageParams, ShortMessageLoginParams } from '@packages/authentication'
import { Component, Ref, Vue, Watch } from 'vue-property-decorator'
import { WaitToRegisterAccount } from '@api/module/customer/user/models/WaitToRegisterAccount'
import { ElForm } from 'element-ui/types/form'
import LoginDialogModule from '@/portal/store/login/LoginDialogModule'
import UserModule from '@api/module/customer/user/UserModule'

export class LoginResult {
  code: number
  message: string

  constructor(code: number, message: string) {
    this.code = code
    this.message = message
  }

  isSuccess() {
    return this.code === 200
  }
}

const countDownTime = 120
@Component
export default class extends Vue {
  validateCodePic = ''
  phoneCaptchaMustValidate = false
  // 发送后倒计时计时
  countDownTime = countDownTime
  applyingCaptcha = false
  passwordLogin = false
  rememberPassword = this.$authentication.rememberLoginInfo.longTerm
  loginIng = false
  // 实为布尔值，此处赋值帐号值。用来解决记住帐号和密码后，图形验证码无法输入问题
  isPhoneNumberValid = false
  getMessageCoding = false
  formData = {
    account: this.$authentication.rememberLoginInfo.account,
    password: this.$authentication.rememberLoginInfo.password,
    accountType: 2,
    extAttributes: '',
    // 图形验证码
    captcha: '',
    phoneCaptcha: ''
  }
  timer = 0
  isCaptchaValid = false
  isShortMessageCaptchaValid = false
  loginResult = new LoginResult(200, '')
  rules = {}

  @Watch('isPhoneNumberValid', { immediate: true, deep: true })
  isPhoneNumberValidChange() {
    console.log(this.isPhoneNumberValid)
  }

  hideBandingDialog() {
    console.log('重写')
  }

  async created() {
    this.rules = {
      phoneCaptcha: [
        {
          required: true,
          trigger: ['blur', 'change'],
          validator: async (rules: any, value: any, callback: (message?: any) => {}) => {
            if (!value) {
              return callback(new Error('请输入短信验证码'))
            } else if (!/^\d{6}$/.test(value)) {
              return callback(new Error('请输入6位短信验证码'))
            } else {
              if (this.phoneCaptchaMustValidate) {
                if (!this.$authentication.shortMessageCaptchaTicket) {
                  return callback(new Error('请先获取短信验证码'))
                }
                try {
                  await this.$authentication.validateShortMessageCaptcha(value)
                  this.isShortMessageCaptchaValid = true
                  return callback()
                } catch (e) {
                  return callback(new Error('验证码验证错误'))
                }
              }
            }
            return callback()
          }
        }
      ],
      account: [
        {
          required: true,
          validator: async (rules: any, value: any, callback: (message?: any) => {}) => {
            const message = this.passwordLogin ? '账号' : '手机号'
            if (!value) {
              this.isPhoneNumberValid = false
              return callback(new Error(`请输入${message}`))
            } else {
              // if (!this.passwordLogin) {
              // 宽松匹配
              if (!/^(?:(?:\+|00)86)?1\d{10}$/.test(value)) {
                this.isPhoneNumberValid = false
                return callback(new Error('手机号格式不正确'))
                // }
              }
            }
            this.isPhoneNumberValid = true
            callback()
          },
          trigger: ['blur', 'change']
        }
      ],
      password: [
        {
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }
      ],
      captcha: [
        {
          // 以大写小写字母或者数字组合的4位
          regexp: /^[a-zA-z0-9]{4}$/,
          validator: async (rules: any, value: any, callback: (message?: any) => {}) => {
            if (value && rules.regexp.test(value)) {
              try {
                await this.$authentication.validateCaptcha(value)
                this.isCaptchaValid = true
                callback()
              } catch (e) {
                await this.refreshValidateCodePic()
                this.isCaptchaValid = false
                callback(new Error('验证失败'))
              }
            } else {
              this.isCaptchaValid = false
              callback(new Error('验证码为4位数'))
            }
          },
          required: true,
          trigger: 'change'
        }
      ]
    }
    // 获取登录票
    try {
      await this.refreshValidateCodePic()
    } catch (e) {
      // console.log(e)
    }
  }

  destroyed() {
    this.stopTimerCount()
  }

  stopTimerCount() {
    window.clearInterval(this.timer)
  }

  countDown() {
    this.timer = setInterval(() => {
      this.countDownTime--
      if (this.countDownTime <= 0) {
        this.getMessageCoding = false
        this.stopTimerCount()
        this.countDownTime = countDownTime
      }
    }, 1000)
  }

  // 获取短信验证码
  async getPhoneCaptcha() {
    this.applyingCaptcha = true
    const sendMessage = new SendMessageParams()
    sendMessage.phoneNumber = this.formData.account
    sendMessage.accountType = AccountType.customer
    try {
      const result = await this.$authentication.sendMessage(sendMessage)
      this.getMessageCoding = true
      if (result.status.code === 4001) {
        this.loginResult = result.status
        return
      }
      this.countDown()
    } catch (e) {
      console.log(e)
      const message = e?.message || '获取验证码失败，'
      this.$message.warning(message)
    } finally {
      this.applyingCaptcha = false
    }
  }

  async refreshValidateCodePic() {
    const { data: captchaImg } = await this.$authentication.applyCaptcha()
    this.validateCodePic = `data:image/jpeg;base64,${captchaImg.b64Image}`
  }

  async doPasswordLogin() {
    const loginParams = new LoginParams()
    loginParams.account = this.formData.account
    loginParams.password = this.formData.password
    loginParams.longTerm = this.rememberPassword
    loginParams.accountType = AccountType.customer
    return this.$authentication.login(loginParams)
  }

  async shortMessageLogin() {
    const shortMessageLoginParams = new ShortMessageLoginParams()
    shortMessageLoginParams.phoneNumber = this.formData.account
    shortMessageLoginParams.smsCode = this.formData.phoneCaptcha
    shortMessageLoginParams.longTerm = this.rememberPassword
    return this.$authentication.shortMessageLogin(shortMessageLoginParams)
  }

  @Ref('loginForm')
  LoginForm: ElForm

  async doLogin() {
    try {
      await this.LoginForm.validate()
    } catch (e) {
      // console.log(e)
    }
  }

  thirdLogin(type: string) {
    this.$authentication.thirdParty.apply(`${location.origin}${this.$router.resolve('/binding-wx').href}`, true)
    window.openBidingDialog = () => {
      LoginDialogModule.setShowLoginDialog(false)
      LoginDialogModule.setShowBindingWeixinDialog(true)
    }
    window['loginSuccess'] = () => {
      this.$emit('login-result', true)
    }
    if (type !== 'wx') {
      this.$confirm('暂未开放' + type, '友情提示')
    }
  }

  phoneCaptchaTicket = ''

  async registerAndBind(token: string, account: WaitToRegisterAccount) {
    try {
      // const validateResult = await this.$authentication.validateShortMessageCaptcha(this.formData.phoneCaptcha)
      // this.isShortMessageCaptchaValid = true
      // console.log(validateResult)
      await UserModule.doRegisterUserAndBindWXWithPhoneCaptchaToken({
        wxToken: token,
        account,
        captchaToken: this.$authentication.shortMessageCaptchaToken
      })
    } catch (error) {
      this.$message.error('系统异常,请联系管理员' + error?.message)
      console.error(error)
    }
  }

  async bindByToken(token: string, account: string) {
    try {
      const bindResult = await UserModule.bindWXByTokenAndLoginInputForOpenAPI({
        loginInput: account,
        token: token,
        dontLoad: true
      })
      if (bindResult.isSuccess()) {
        await this.bindSuccess()
      } else {
        let message = '绑定失败'
        if (bindResult.code === 30006) {
          message = '请重新扫码登录'
        }
        this.loginResult = new LoginResult(bindResult.code, message)
      }
    } catch (e) {
      console.log(e)
    }
  }

  isExists = false

  async doBindWeixin(phoneNumber: string, password: string) {
    const account = new WaitToRegisterAccount()
    account.phoneNumber = phoneNumber
    account.sourceType = 1
    account.registerType = 41
    account.password = password
    account.nickName = phoneNumber
    try {
      const token = this.$authentication.thirdParty.getWxloginToken() || ''
      if (this.isExists) {
        if (token) {
          await this.bindByToken(token, this.formData.account)
        }
      } else {
        await this.registerAndBind(token, account)
        await this.bindSuccess()
      }
    } catch (e) {
      // todo
      console.log(e)
    }
  }

  async bindSuccess() {
    const wxLoginToken = this.$authentication.thirdParty.getWxloginToken() || ''
    console.log('wxLoginToken:' + wxLoginToken)
    await this.$authentication.wxTokenLogin(wxLoginToken)
    this.hideBandingDialog()
    this.$message.success('绑定成功!！')
    this.$emit('login-result', true)
  }
}
